import React from 'react';
import {OrbitComponent} from '../../../../base-components/orbit-component/orbit-component';
import {TrailerOrStripeImageComponent} from '../../../common/trailer-or-stripe-image/trailer-or-stripe-image.component';
import {GamePreviewInfoContainerComponent} from '../../../common/game-info-container/game-preview-info-container.component';
import {observer} from 'mobx-react';
import {PcGamePreviewTitleComponent} from './title/pc-game-preview-title.component';
import {LobbyGameInfoBox} from '../../boxes/lobby-game-info/lobby-game-info.box';
import classNames from 'classnames';
import {STICKY} from '../../../../../themes/css-global-classes';
import {GameInfo} from '../../../../../services/games/game-info';


export interface GameInfoPreviewComponentProps {
  isSticky?: boolean;
  gameInfo: GameInfo;
}

export const GameInfoPreviewComponent = observer(
  class GameInfoPreviewComponent extends OrbitComponent<GameInfoPreviewComponentProps> {

    private _onMouseEnter = () => {
      this.services.lobbyGameInfoPreview.pinCurrentGamePreview();
    };

    private _onMouseLeave = () => {
      this.services.lobbyGameInfoPreview.unPinCurrentGamePreview();
    };


    render() {
      let gameInfo = this.props.gameInfo;
      return (
        <LobbyGameInfoBox className={classNames('cy-game-info-preview', gameInfo.gameCategoryClassName, {[STICKY]: this.props.isSticky})}
             onMouseEnter={this._onMouseEnter}
             onMouseLeave={this._onMouseLeave}>
             <TrailerOrStripeImageComponent gameInfo={gameInfo}/>
             <GamePreviewInfoContainerComponent gameInfo={gameInfo} gameTitleComponent={<PcGamePreviewTitleComponent gameTitle={gameInfo.title} />}/>
        </LobbyGameInfoBox>
      );
    }
  }
);


